export const AF_TYPE = {
  AF: 'af',
  WL: 'wl',
};
